module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a4-5-dd282fe6868fd3d2f1d440069fa71427.jpg";